
import { useNavigate } from "react-router-dom";

import { Button, Spin } from "antd";
import styles from './index.module.less'
import CardItem from "@/pages/baseProduct/productMonitor/components/cardItem";
import dayjs from "dayjs";
import { useCallback, useEffect } from "react";
import { priceWarningDetailsSummary, standardWarningDetailsSummary } from "@/services/product.ts";
import { useSetState } from "ahooks";

const ProductMonitor = () => {
  const navigate = useNavigate()
  const [state, setState] = useSetState({
    competitionSummary: {},
    generalSummary: {},
    loading: false,
  })

  const getData = useCallback(async () => {
    try {
      setState({loading: true})
      await priceWarningDetailsSummary().then(res => {
        setState({competitionSummary: {...res || {}, title: '竞争定价', modalType: 'competition'}})
      })
      await standardWarningDetailsSummary().then(res => {
        setState({generalSummary: {...res || {}, title: '通项标配', modalType: 'general'}})
      })
    } finally {
      setState({loading: false})
    }
  }, [setState])

  useEffect(() => {
    getData()
  }, [getData]);

  const onConfig = () => {
    navigate('/config/baseProduct/productMonitor/ruleConfiguration')
  }

  // 计算统计时间：若当前时间小于当日 01:30，则显示前一天的 01:30，否则显示当日的 01:30
  const now = dayjs()
  const todayOneThirty = now.hour(1).minute(30).second(0)
  const statTime = now.isBefore(todayOneThirty)
    ? todayOneThirty.subtract(1, 'day')
    : todayOneThirty

  return <div className={styles.wrap}>
    <div className={`${styles.flexBetween} ${styles.titleBox}`}>
      <div className={styles.title}>产品监控</div>
      <div>
        <span className={styles.time}>数据统计时间: {statTime.format('YYYY-MM-DD HH:mm:ss')}</span>
        <Button type={'primary'} onClick={onConfig} style={{marginLeft: 10}}>规则设置</Button>
      </div>
    </div>
    <Spin spinning={state.loading}>
      <div className={styles.cardsWrap}>
        <CardItem data={state.competitionSummary}/>
        <CardItem data={state.generalSummary}/>
      </div>
    </Spin>
  </div>
}

export default ProductMonitor